import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CroppedMockup } from '../CroppedMockup';
import { CtaButton } from '../CtaButton';
import { volumes } from '../../data/volumes';
export function VolumesSection() {
  return <section className="bg-ink-soft px-5 py-20 md:py-28" data-id="element-245" data-mp="2rtq4www8h55i">
      <div className="mx-auto max-w-6xl" data-id="element-246" data-mp="2rs59z660bk74">
        <SectionHeading title="3 volúmenes. Un solo método." subtitle="Cada volumen cumple una función concreta y se conecta con el siguiente." data-id="element-247" data-mp="2e2v324k5jobf" />

        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-3 gap-3 md:gap-6" data-id="element-248" data-mp="2iv4q9ctvuaa0">
          {volumes.map(v => <CroppedMockup key={v.label} crop={v.crop} alt={`Portada del ${v.label}`} className="w-full" data-id="element-249" data-mp="293i9l0yrzizv" />)}
        </div>

        <div className="mt-16 space-y-8" data-id="element-250" data-mp="1v4s8la8u4z68">
          {volumes.map(v => <article key={v.label} className="rounded-3xl border border-gold/30 bg-ink p-6 md:p-10" data-id="element-251" data-mp="1z5uaxzy1trcf">
              <div className="grid gap-8 lg:grid-cols-[1fr_1.1fr] lg:gap-12" data-id="element-252" data-mp="1fiqsdg4phvdg">
                <div data-id="element-253" data-mp="1ak777hxxsnm5">
                  <p className="inline-block rounded-full bg-gold px-4 py-1 font-display text-sm font-extrabold uppercase tracking-widest text-black" data-id="element-254" data-mp="1akozy4le4jpb">
                    {v.tag}
                  </p>
                  <p className="mt-5 text-sm font-bold uppercase tracking-[0.2em] text-neutral-500" data-id="element-255" data-mp="1khtky13i294j">{v.label}</p>
                  <h3 className="mt-2 font-display text-2xl font-black uppercase leading-tight text-cream md:text-3xl" data-id="element-256" data-mp="wttyveh4v6wa">{v.title}</h3>
                  <p className="mt-4 text-xl font-semibold text-gold-light md:text-2xl" data-id="element-257" data-mp="rvingzb6woby">{v.headline}</p>
                  {v.intro && <p className="mt-4 text-lg leading-relaxed text-neutral-400 md:text-xl" data-id="element-258" data-mp="16keviwd8y1ck">{v.intro}</p>}
                  {v.flowLabel && <p className="mt-6 text-sm font-bold uppercase tracking-wider text-neutral-500" data-id="element-259" data-mp="e2171ndsvrq5">{v.flowLabel}</p>}
                  <p className={`${v.flowLabel ? 'mt-2' : 'mt-6'} border-y border-gold/25 py-3 font-display text-base font-extrabold uppercase tracking-wide text-gold md:text-lg`} data-id="element-260" data-mp="93znl1cgpqe5">
                    {v.flow.join(' → ')}
                  </p>
                  {v.extra && <p className="mt-5 text-lg text-neutral-300" data-id="element-261" data-mp="12quexmzzqg9g">{v.extra}</p>}
                </div>
                <div data-id="element-262" data-mp="17lqdz73na3w2">
                  <p className="text-sm font-bold uppercase tracking-wider text-neutral-500" data-id="element-263" data-mp="1cigws26u3dl6">{v.listLabel}</p>
                  <ul className="mt-4 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-264" data-mp="fszgyue50b5r">
                    {v.list.map(item => <li key={item} className="flex items-center gap-2.5 text-lg text-cream" data-id="element-265" data-mp="jv47hk9agro6">
                        <CheckIcon className="h-4 w-4 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-266" data-mp="os4djv651ufa" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-14" data-id="element-267" data-mp="256crj1cuevfb">
          <CtaButton data-id="element-268" data-mp="255kwbrn5qzpk">Quiero el sistema completo</CtaButton>
        </div>
      </div>
    </section>;
}